<template>
  <div>
    <RouterView />
  </div>
</template>

<script>
import { middleware } from '@/routes/guards';
import { pageMethods } from '@/store/helper';

export default {
  name: 'AccountPageSingle',
  props: {
    accountId: {
      type: String,
      required: true,
    },
    pageId: {
      type: String,
      required: true,
    },
  },
  beforeRouteEnter: middleware('account-permission:read pages'),
  created() {
    this.setCurrent(this.pageId);
  },
  beforeRouteUpdate(to, from, next) {
    const { pageId: pageIdTo } = to.params;
    const { pageId: pageIdFrom } = from.params;
    if (pageIdTo !== pageIdFrom) {
      this.setCurrent(pageIdTo);
    }
    next();
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...pageMethods,
  },
};
</script>
